import _sortBy from "lodash/sortBy";

const PromoMobileProductsFilters = ({
  filters,
  onFiltersChange,
  activeFilters,
}) => (
  <ul className="ml-2 mt-4 group-with-promoDarkTheme:text-white">
    {_sortBy(filters, "order").map((filter) => {
      const hasFilter = activeFilters[filter.attribute_code];

      return (
        <li key={filter.slug} className="mb-4">
          <div className="mb-2 font-medium">{filter.label}</div>

          {filter.options &&
            _sortBy(filter.options, "order").map((option) => {
              const isActive =
                hasFilter &&
                activeFilters[filter.attribute_code].includes(option.value);

              return (
                <div key={option.slug} className="mb-2">
                  <a
                    className={`capitalize leading-18.2 -tracking-0.39 cursor-pointer select-none ${
                      isActive ? "is-active" : ""
                    }`}
                    onClick={(event) => {
                      event.preventDefault();

                      onFiltersChange({
                        filter,
                        option,
                      });
                    }}
                  >
                    <span
                      className={`checkbox-control inline-block align-middle w-5 h-5 p-1 mr-2 border-gray-light border-2 rounded-4px bg-white ${
                        isActive
                          ? "checked"
                          : "group-with-promoDarkTheme:bg-black"
                      }`}
                    >
                      <svg
                        className=""
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                        focusable="false"
                      >
                        <path
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          d="M1.73 12.91l6.37 6.37L22.79 4.59"
                        />
                      </svg>
                    </span>
                    {option.label} ({option.count})
                  </a>
                </div>
              );
            })}
        </li>
      );
    })}
  </ul>
);

export default PromoMobileProductsFilters;
